import { Box, FormControlLabel, IconButton, Typography } from "@mui/material";
import { CustomWidthTooltip } from "mui-toolkit/CustomWidthTooltip";

import { setStorageValue } from "../../core/useLocalStorageForChat";
import { MicrophoneIcon } from "../Icons/Icons";

export const SettingsContentComponent = ({ isTilleyChat = false, onAudioModeChange, audioMode }) => {
  const AUDIO_MODE_KEY = "tilley_audio_mode";
  const handleAudioModeToggle = () => {
    const newValue = !audioMode;
    setStorageValue(AUDIO_MODE_KEY, newValue);
    onAudioModeChange(newValue);
  };

  if (isTilleyChat) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CustomWidthTooltip
          key={AUDIO_MODE_KEY}
          title={`${audioMode ? "ON" : "OFF"} Voice input and output capabilities`}
          placement="top"
        >
          <IconButton
            onClick={handleAudioModeToggle}
            sx={{
              padding: "8px",
            }}
          >
            <MicrophoneIcon
              sx={{
                color: audioMode ? "primary.main" : "text.disabled",
                "[data-mui-color-scheme='dark'] &": {
                  color: audioMode ? "primary.light" : "text.disabled",
                },
              }}
            />
          </IconButton>
        </CustomWidthTooltip>
      </Box>
    );
  }

  return (
    <div className="main">
      <div className="main-header">
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Settings
        </Typography>
      </div>
      <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 500, mb: 1 }}>
          Audio Settings
        </Typography>
        <FormControlLabel
          control={
            <CustomWidthTooltip
              key={AUDIO_MODE_KEY}
              title={`${audioMode ? "ON" : "OFF"} Voice input and output capabilities`}
              placement="top"
            >
              <IconButton
                onClick={handleAudioModeToggle}
                sx={{
                  padding: "8px",
                }}
              >
                <MicrophoneIcon
                  sx={{
                    color: audioMode ? "primary.main" : "text.disabled",
                  }}
                />
              </IconButton>
            </CustomWidthTooltip>
          }
          label={
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Audio Mode
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {audioMode ? "ON" : "OFF"} - Voice input and output capabilities
              </Typography>
            </Box>
          }
          sx={{
            alignItems: "center",
            "& .MuiFormControlLabel-label": { ml: 2 },
          }}
        />
      </Box>
    </div>
  );
};
